export default __webpack_public_path__ + "images/6883c4c99168a1df880771c25cf80eee.png";